import React from 'react';
import { oneOfType, number, string, array, bool, func } from 'prop-types';
import { get, map, filter, head } from 'lodash';
import { withApollo } from 'react-apollo';
import { Table, Modal } from 'antd';
import TableContainer from '../../../shared/Table';
import { generateTraceabilityUtil, validations } from '../../../../utils/misc';
import { TableCount, Text, Icon, IconContainer, Row, Button, FlexContainer, If, Loading } from '../../../common';
import Mutation from '../../../graphql/Mutation';
import DELETE_USER from '../../../../queries/DELETE_USER';
import UserActions from './UserActions';
import MobileTable from './MobileTable';
import StatusUserTag from './StatusUserTag';
/**
 *
  Definition from back
 */

class UsersTable extends React.Component {
    static propTypes = {
        data: array,
        loading: bool,
        onUserClicked: func,
        total: oneOfType([number, string]),
        onCompleted: func,
        hideCount: bool,
        isMobile: bool
    }

    state = {
        visible: false,
        selectedUserToDelete: null,
        isMobile: false
    }

    _toggleModal = () => this.setState(({ visible }) => ({ visible: !visible, selectedUserToDelete: null }))

    handleCancel = () => this._toggleModal()

    deleteUserModal = () => {
        const { visible, selectedUserToDelete } = this.state;
        if (!visible && !selectedUserToDelete) return null;
        return (
            <Modal
                closable={false}
                title={null}
                visible={visible}
                footer={null}
            >
                <Mutation
                    mutation={DELETE_USER}
                    refetchQueries={['getUsersFeed']}
                    onCompleted={() => window.location.reload()}
                    onError={
                        <FlexContainer margin={30} align='center' direction='column'>
                            <IconContainer color='#f38630'>
                                <Icon name='trash' color='#ffffff' size={46.8} />
                            </IconContainer>
                            <FlexContainer mY={30} direction='column' align='center'>
                                <Row justify='center'>
                                    <Text text='Error al intentar eliminar el usuario' />
                                </Row>
                            </FlexContainer>
                            <FlexContainer justify='flex-end' style={{ width: '100%' }}>
                                <Button
                                    text='Cerrar'
                                    style={{ width: '100px' }}
                                    onClick={this.handleCancel}
                                />
                            </FlexContainer>
                        </FlexContainer>
                    }
                >
                    {({ data, loading, updateFn }) => (
                        <FlexContainer margin={30} align='center' direction='column'>
                            <IconContainer color='#f38630'>
                                <Icon name='trash' color='#ffffff' size={46.8} />
                            </IconContainer>
                            <FlexContainer mY={30} direction='column' align='center'>
                                <Row justify='center'>
                                    <Text
                                        text={`Eliminarás el usuario de ${get(selectedUserToDelete, 'firstName', 'Nombre')} ${get(selectedUserToDelete, 'lastName', 'Apellido')},\u00a0`}
                                    />
                                    <Text strong text={get(selectedUserToDelete, 'email', 'nombre.apellido@dominio.cl')} />
                                </Row>
                                <Row>
                                    <Text centered text='¿Estás seguro? Esta acción es permanente y no se podrá reversar.' />
                                </Row>
                            </FlexContainer>
                            <FlexContainer justify='flex-end' style={{ width: '100%' }}>
                                <Button
                                    link
                                    text='btn.action.cancel'
                                    style={{ width: '100px' }}
                                    onClick={this.handleCancel}
                                />
                                <Button
                                    disabled={loading}
                                    loading={loading}
                                    text='btn.action.confirm'
                                    style={{ width: '100px' }}
                                    onClick={() =>
                                        updateFn({
                                            variables: { email: get(selectedUserToDelete, 'email', 'nombre.apellido@dominio.cl') }
                                        }).then(async () => {
                                            const { client } = this.props;
                                            await generateTraceabilityUtil(client, { actionId: 2 });
                                            this.handleCancel();
                                        })
                                    }
                                />
                            </FlexContainer>
                        </FlexContainer>
                    )}
                </Mutation>
            </Modal>
        );
    }

    columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            width: 50,
            render: (text, item, index) => {
                return <Text text={text} />;
            }
        },
        {
            title: 'Nombre',
            dataIndex: 'firstName',
            key: 'firstName'
        },
        {
            title: 'Apellido',
            dataIndex: 'lastName',
            key: 'lastName'
        },
        {
            title: 'Empresa',
            dataIndex: 'company',
            key: 'company',
            render: value => value || '-'
        },
        {
            title: 'RUT',
            dataIndex: 'document',
            key: 'document',
            render: (value) => validations.document.format(value)
        },
        {
            title: 'Estado',
            dataIndex: 'statusUser',
            key: 'statusUser',
            render: value => <StatusUserTag value={value} />
        },
        {
            title: 'Acciones',
            dataIndex: 'actions',
            key: 'actions',
            render: (value, item, index) => {
                const { permission, userModuleType } = this.props;
                const userActionsProps = {
                    permission,
                    userModuleType,
                    onUserClicked: () => this.props.onUserClicked(item, index),
                    onClickTrash: () => this.setState({ selectedUserToDelete: item }, () => this.setState({ visible: true }))
                };
                return <UserActions {...userActionsProps} />;
            }
        }
    ];

    render () {
        const { data, loading, total, groups, hideCount, isMobile, ...props } = this.props;
        const users = map(data, (user) => {
            const alias = map(get(user, 'profiles'), (profile) => get(head(filter(groups, { id: profile })), 'alias'));
            return { ...user, profiles: alias };
        });
        return (
            <If
                condition={isMobile}
                then={
                    <If
                        condition={loading}
                        then={<Loading loading />}
                        else={
                            <MobileTable
                                {...this.props}
                                onClickTrash={item => this.setState({ selectedUserToDelete: item }, () => this.setState({ visible: true }))}
                                data={data}
                            />
                        }
                    />
                }
                else={
                    <TableContainer {...props}>
                        {({ onRow }) => (
                            <>

                                <Table
                                    rowKey={({ email }) => email}
                                    loading={loading}
                                    lassName='bo-table'
                                    size='small'
                                    columns={this.columns}
                                    dataSource={users}
                                    pagination={false}
                                    onRow={(record, rowIndex) => onRow(record, rowIndex)}
                                />
                                { this.deleteUserModal() }
                            </>
                        )}
                    </TableContainer>
                }
            />
        );
    }
}

export default withApollo(UsersTable);
